import Game01 from "./Game01";

export default {
  tutorial: {
    Game01,
  },
};
